import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { State as CaLabelingState, Update } from '~/CaLabeling/reducer';
import BasicSaveActivityIndicator, { Status, Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

const selectStatus = memoizeOne((groupId: string, update: Update | null): Status | null => {
	if (!update || update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Statuses.saving;
		case 'updated':
			return Statuses.saved;
		case 'failed':
			return Statuses.failed;
		default:
			return null;
	}
});

function mapStateToProps(
	state: { caLabeling: CaLabelingState },
	{ groupId }: { groupId: string; hideAfterMilliseconds: number }
): {
	status: Status | null;
} {
	return {
		status: selectStatus(groupId, state.caLabeling.update),
	};
}

export const SaveActivityIndicator = connect(mapStateToProps)(BasicSaveActivityIndicator);
